import React, { forwardRef } from 'react';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import LabelImportant from '@material-ui/icons/LabelImportant';

const TypeStatement = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <LabelImportant {...props} ref={ref} />
));

TypeStatement.displayName = 'TypeStatement';

export default TypeStatement;
